<style lang="less" scoped>
    .ws-panel-heading {
        .head-actions {
            .el-input {
                width: auto !important;
            }
        }
    }
</style>
<template>
	<section class="ws-panel">
		<header class="ws-panel-heading" :class="{'hidden': hideHeader}">
			{{title}}
			<el-button size="mini" v-if="rebak"><i class="fa fa-mail-reply" @click="back">返回</i></el-button>
			<div class="pull-right head-actions">
				<slot name="panel_head_actions"></slot>
			</div>
		</header>
		<div class="ws-panel-body">
            <slot name="panel_query"></slot>
			<slot name="panel_body"></slot>
			<div class="ws-pagination" v-if="showPage">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageNum"
				 :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="page.total" style="float:right">
				</el-pagination>
			</div>
		</div>
	</section>
</template>
<script>
	export default {
		props: {
            //是否保持之展开一个菜单
            title : {
                type: String
            },
            rebak: {
            	type: Boolean
            },
            hideHeader: {
            	type: Boolean,
            	default: false
            },
			page: {
				type: Object
			}
        },
		computed: {
			/**
			 * 显示分页内容
			 */
			showPage() {
				return this.page;
			}
		},
        methods: {
        	back() { //返回上一个路由
        		this.$router.back();
        	},
			handleSizeChange(val) {
				this.page.pageSize = val;
				this.$emit('page-change', this.page);
			},
			handleCurrentChange(val) {
				this.page.pageNum = val;
				this.$emit('page-change', this.page);
			}
        }
	}
</script>


// WEBPACK FOOTER //
// panel.vue?2970123a